import { render } from "./TakeTwayTrappe.vue?vue&type=template&id=2cad46ca"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakeTwayTrappe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cad46ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cad46ca', __exports__)) {
    api.reload('2cad46ca', __exports__)
  }
  
  module.hot.accept("./TakeTwayTrappe.vue?vue&type=template&id=2cad46ca", () => {
    api.rerender('2cad46ca', render)
  })

}


export default __exports__